/* Сводка — корешок варианта: лежит поверх колонки, поэтому светлее её, и
   отделена линией отрыва, как корешок билета. */
.panel {
  flex: none;
  position: sticky;
  bottom: 0;
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
  /* Отступы те же, что у таймлайна рядом: первая строка итогов встаёт вровень
     с первой карточкой, низ заканчивается на одной высоте с последней. */
  padding: var(--sp-4) var(--sp-5) var(--sp-6);
  background: var(--surface-raised);
  -webkit-backdrop-filter: var(--glass-blur);
  backdrop-filter: var(--glass-blur);
  border-top: 1px dashed var(--border-strong);
  /* Сводка стоит в самом низу колонки и упирается в её скруглённые углы. Своя
     заливка углов не знает и рисует их прямыми — на крупном радиусе это видно
     как вылезающий из-под обводки прямоугольник. Радиус внутренний: у внешнего
     край шёл бы вровень с обводкой, а не под ней. */
  border-radius: 0 0 var(--inner-radius) var(--inner-radius);
}

/* Когда сводка встаёт сбоку от таймлайна, она тянется на всю высоту варианта,
   а линия отрыва переезжает на левый край. Липнуть больше некуда и незачем:
   блок и так виден целиком. */
@container variant (min-width: 720px) {
  .panel {
    position: static;
    height: 100%;
    border-top: none;
    border-left: 1px dashed var(--border-strong);
    /* Сбоку сводка занимает всю высоту, поэтому из углов колонки ей достаётся
       только правый нижний: сверху она упирается в шапку. */
    border-radius: 0 0 var(--inner-radius) 0;
  }
}

.totalRow {
  display: flex;
  align-items: baseline;
  gap: var(--sp-3);
}

.total {
  font-size: var(--fs-xl);
  font-weight: 700;
}

.badge {
  padding: 1px var(--sp-3);
  border-radius: var(--radius);
  background: var(--surface-2);
  border: var(--bw) solid var(--border-strong);
  color: var(--text-2);
  font-size: var(--fs-xs);
}

.line {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  font-size: var(--fs-sm);
  color: var(--text-2);
}

.metaRow {
  display: flex;
  gap: var(--sp-5);
  padding-top: var(--sp-2);
  border-top: 1px solid var(--border);
}

.metaItem {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.metaLabel {
  font-size: var(--fs-xs);
  color: var(--text-3);
}

.warnBtn {
  align-self: flex-start;
  padding: var(--sp-1) var(--sp-3);
  border-radius: var(--radius);
  border: var(--bw) solid transparent;
  font-size: var(--fs-xs);
  font-weight: 600;
  cursor: pointer;
}

.warnBtnWarn {
  background: var(--warn-bg);
  box-shadow: var(--glow-warn);
  border-color: var(--warn-border);
  color: var(--warn);
}

.warnBtnError {
  background: var(--error-bg);
  box-shadow: var(--glow-error);
  border-color: var(--error-border);
  color: var(--error);
}

.breakdown {
  border-top: 1px solid var(--border);
  padding-top: var(--sp-2);
}

.breakdownToggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: var(--sp-1) 0;
  background: transparent;
  border: none;
  color: var(--text-2);
  font-size: var(--fs-sm);
  cursor: pointer;
  text-align: left;
}

.chevron {
  color: var(--text-3);
}

.breakdownList {
  display: flex;
  flex-direction: column;
  gap: var(--sp-1);
  margin: var(--sp-2) 0 0;
  padding: 0;
  list-style: none;
}

.breakdownItem {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  font-size: var(--fs-sm);
  color: var(--text-2);
}
